import { Tab, TabList, Tabs } from '@chakra-ui/react';
import React from 'react';

import { TAPE_BUILDER_MODES, TapeBuilderMode } from './GraphContext';

type ModeProps = {
  mode: TapeBuilderMode;
  setMode: (mode: TapeBuilderMode) => void;
  disabled?: boolean;
};

export const TapeBuilderModeSelect = ({
  setMode,
  mode,
  disabled,
}: ModeProps): React.ReactElement => {
  const activeIndex = TAPE_BUILDER_MODES.indexOf(mode);

  return (
    <Tabs
      variant="line"
      size="sm"
      index={activeIndex === -1 ? 0 : activeIndex}
      onChange={(index) => setMode(TAPE_BUILDER_MODES[index])}
    >
      <TabList borderBottom="none">
        {TAPE_BUILDER_MODES.map((modeOption) => (
          <Tab
            key={modeOption}
            isDisabled={disabled}
            // Compact: the theme injects a large top margin + tall padding on
            // tabs; strip both so the strip reads as a toolbar, not a page tab.
            mt="0"
            py="1"
            px="3"
            fontSize="sm"
            lineHeight="1.2"
          >
            {modeOption}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};
